import * as React from 'react';
import { toClass } from 'recompose';

import Alerts from '../../Alerts';
import withActivityList from '../withActivityList';
import ActivityList from './ActivityList';
import AthleteDetails from './AthleteDetails';

const ActivityListWithData = withActivityList(ActivityList);

export default toClass(() => (
    <>
        <AthleteDetails />
        <Alerts />
        <ActivityListWithData />
    </>
));



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityListScene/index.tsx